import { CompanyLogo, LogoNames } from './CompanyLogo'

function LogoGrid() {
  const companies: LogoNames[] = [
    'vimeo',
    'cargurus',
    'intercom',
    'clickUp',
    'substack',
    'super',
    'goPuff',
    'checkout',
    // 'clair',
    // 'tails',
    // 'noths',
    // 'beautyPie',
    // 'chiliPiper',
    // 'software',
    // 'tmm',
    // 'upEquity',
    // 'flipsideCrypto',
    // 'tails-2',
  ]

  return (
    <section className="flex w-full flex-col items-center gap-12 px-5 py-16 sm:px-10 xl:px-[100px] xl:py-20">
      <h4 className="font-roboto text-center text-base font-bold leading-[150%] xl:text-lg">
        Trusted by world class data teams.
      </h4>

      <div className="flex w-full flex-col items-center justify-center gap-10 xl:w-[780px]">
        <div className="flex w-full flex-wrap items-center justify-between gap-x-5 gap-y-10">
          {companies.slice(0, 4).map((company) => (
            <CompanyLogo key={company} name={company} />
          ))}
        </div>
        <div className="flex w-full flex-wrap items-center justify-between gap-x-5 gap-y-10">
          {companies.slice(4, 8).map((company) => (
            <CompanyLogo key={company} name={company} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default LogoGrid
